/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coaching_Chat_EmptyInputs */

const en_us2_coaching_chat_empty = /** @type {(inputs: Coaching_Chat_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No messages yet.`)
};

const pt_br2_coaching_chat_empty = /** @type {(inputs: Coaching_Chat_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma mensagem ainda.`)
};

const pt_pt2_coaching_chat_empty = /** @type {(inputs: Coaching_Chat_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma mensagem ainda.`)
};

/** @type {(inputs: Coaching_Chat_EmptyInputs) => LocalizedString} */
const es_419_coaching_chat_empty = en_us2_coaching_chat_empty;

/** @type {(inputs: Coaching_Chat_EmptyInputs) => LocalizedString} */
const fr_fr2_coaching_chat_empty = en_us2_coaching_chat_empty;

/** @type {(inputs: Coaching_Chat_EmptyInputs) => LocalizedString} */
const de_de2_coaching_chat_empty = en_us2_coaching_chat_empty;

/** @type {(inputs: Coaching_Chat_EmptyInputs) => LocalizedString} */
const it_it2_coaching_chat_empty = en_us2_coaching_chat_empty;

/**
* | output |
* | --- |
* | "No messages yet." |
*
* @param {Coaching_Chat_EmptyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coaching_chat_empty = /** @type {((inputs?: Coaching_Chat_EmptyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaching_Chat_EmptyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coaching_chat_empty(inputs)
	if (locale === "es-419") return es_419_coaching_chat_empty(inputs)
	if (locale === "pt-PT") return pt_pt2_coaching_chat_empty(inputs)
	if (locale === "fr-FR") return fr_fr2_coaching_chat_empty(inputs)
	if (locale === "de-DE") return de_de2_coaching_chat_empty(inputs)
	if (locale === "it-IT") return it_it2_coaching_chat_empty(inputs)
	return en_us2_coaching_chat_empty(inputs)
});
export { coaching_chat_empty as "coaching.chat_empty" }